// adding some validations logic for works form
import { required, minLength, maxLength, url } from 'vuelidate/lib/validators'

export const FORM_PROJECTS_VALIDATIONS = {
  dataForm: {
    projectTypeId: {
      required
    },
    projectTitle: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(100)
    },
    projectLinkProject: {
      required,
      url,
      maxLength: maxLength(255)
    },
    projectLinkOverview: {
      required,
      url,
      maxLength: maxLength(255)
    },
    projectDescription: {
      required,
      minLength: minLength(100)
    },
    projectTeammates: {
      minLength: minLength(5),
      maxLength: maxLength(255)
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formProjects.js